import React from 'react'
import {Box} from '@mui/material'
import styled from 'styled-components'
import {Colors, FontWeights} from '../../../../styledComponents/Constants'

export interface InputError {
    commentId?: number
    title: string,
    messages: string[],
    fileNameList?: string[]
}

interface Props {
    inputError: InputError
}

const NatAdminDisasterCommentError: React.FC<Props> = props => {
    const {title, messages, fileNameList} = props.inputError
    return (
        <ErrorMessageArea>
            <ErrorMessageTitle>
                {title}
            </ErrorMessageTitle>
            <Box height={'5px'}/>
            {messages.map((message, index) =>
                <ErrorMessage key={'errorMessage-' + index}>
                    {message}
                </ErrorMessage>)}
            {
                fileNameList &&
                fileNameList.length > 0 && <>
                    <Box height={'10px'}/>
                    {
                        fileNameList.map((fileName, index) =>
                            <ErrorMessage key={'errorFile-' + index}>
                                {fileName}
                            </ErrorMessage>)
                    }
                </>
            }
        </ErrorMessageArea>
    )
}

export default NatAdminDisasterCommentError

export const ErrorMessageArea = styled.div`
    background: #fbebec;
    padding: 10px;
    margin-bottom: 10px;
    overflow-wrap: anywhere;
    width: 100%;
`

export const ErrorMessageTitle = styled.div`
    color: ${Colors.Alert};
    font-size: 16px;
    font-weight: ${FontWeights.Bold};
    line-height: 24px;
`

export const ErrorMessage = styled.div`
    font-size: 14px;
    line-height: 21px;
`
